import React, { useState, useEffect } from "react";
import "../../components/AddPetType/AddPetType.css";
import axios from "axios";

const AddPetType = ({tokenStorage,openAddProfile,setOpenAddProfile}) => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    PetType: "",
    
    createdBy: "Vishal",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.PetType) {
      console.error("Pet Type is required.");
      // You can show an error message to the user if needed
      return;
    }
  
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}adminpost/AddPetType`,
        formData, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
    
      // Optionally, reset the form
      setFormData({
        PetType: "",
    
        createdBy: "",
      });
      tokenStorage();
      setOpenAddProfile (!openAddProfile);
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };


  return (
    <div className="container-fluid">
      <br />

      <div className="petTypeDetail">
        <div className="petType-form" >
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Pet Type*</td>
            </tr>

            <tr>
              <td>
              <input
                  type="text"
                  name="PetType"
                  value={formData.PetType}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addpetType-button">
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
            <button type="submit" onClick={handleSubmit} style={{marginRight: "10px", backgroundColor: "#5B489D", color: "white", }}>
              Save
            </button>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default AddPetType;
